<nz-modal *ngIf="visible" [(nzVisible)]="visible" [nzTitle]="title" (nzOnCancel)="close()" [nzWidth]="'900px'">
  <ng-container *nzModalContent>
    <nz-table
      nzSize="middle"
      nzShowPagination
      nzShowSizeChanger
      #contentTable
      [nzData]="contentData"
      [nzShowTotal]="manualTotalTemplate"
      [nzLoading]="tableLoading"
    >
      <ng-template #manualTotalTemplate let-total>共{{ contentData.length }}条</ng-template>
      <thead>
        <tr>
          <th><label nz-checkbox [(ngModel)]="isAllChecked" (ngModelChange)="onAllCheck($event)"> </label></th>
          <th>节目名称</th>
          <th>节目ID</th>
          <th>上次修改时间</th>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <tr *ngFor="let data of contentTable.data; let i = index">
            <td>
              <label nz-checkbox [(ngModel)]="data.isChecked" (ngModelChange)="onEachCheck($event, i, data)"></label>
            </td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
  </ng-container>
  <div *nzModalFooter>
    <div style="margin-top: -5px">
      <button nz-button nzType="default" (click)="close()">取消</button>
      <button nz-button nzType="primary" [nzLoading]="loading" (click)="submit()">确定</button>
    </div>
  </div>
</nz-modal>
